import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class LeaveType extends DomainObject {
  @observable name;
}

export default LeaveType;
